import React, { useEffect } from 'react';
import Type from 'prop-types';
import { observer } from 'mobx-react-lite';
import { useSnackbar } from 'notistack';
import { useParams } from 'react-router-dom';
import { ActivityIndicator, Chat } from 'components';
import { useComments, useCreateComment } from 'hooks/api/cascade';
import { userStore } from 'stores';
import styles from './ChatScreen.module.css';

const ChatScreen = observer((props) => {
  const { listHeight } = props;
  const { entityId } = useParams();
  const { isLoading, isError, isSuccess, data: comments, error } = useComments(entityId);
  const { mutate } = useCreateComment(entityId);
  const { user } = userStore;
  const username = user.uname ?? user.username;
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (isError) {
      enqueueSnackbar(error.message, { variant: 'error' });
    }
  }, [isError]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleSendMessage = (message) => {
    mutate(message);
  };

  if (isLoading) {
    return <ActivityIndicator />;
  }

  return (
    <div className={styles.chat} style={{ height: listHeight }}>
      <Chat
        userId={username}
        messages={comments}
        inputProps={{
          className: styles.messageBox,
        }}
        onSendMessage={handleSendMessage}
        isLoading={isSuccess}
      />
    </div>
  );
});

ChatScreen.propTypes = {
  listHeight: Type.number.isRequired,
};

export default ChatScreen;
